import React from 'react';
import Div from '@/shared/Div';
import HeightLoader from './HeightLoader';
import withContentFlags from '@/hoc/withContentFlags';

type DynamicPlaceholderProps = {
  elementID: string;
  className?: string;
  height?: number;
};

const DynamicPlaceholder = (props: DynamicPlaceholderProps) => {
  const { elementID, className, height } = props;
  return (
    <Div id={elementID} className={className} forceRender>
      <HeightLoader height={height || 500} />
    </Div>
  );
};

export default withContentFlags(DynamicPlaceholder);
